import { Stack } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { DurationWithBreakDisplay } from "@src/appV2/redesign/components/DurationWithBreakDisplay";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { calculateTotalPay } from "@src/appV2/redesign/utils/calculateShiftPay";
import { InstantPayIndicator } from "@src/appV2/redesign/WorkerShifts/components/InstantPayIndicator";
import { type ReactNode } from "react";

interface AuctionBottomSheetFooterProps {
  isInstantPay: boolean;
  scheduledShiftDurationInHours: number;
  breakDurationInMinutes: number;
  requiresBreak: boolean;
  remainingWorkDurationInHours: number;
  minutesElapsed: number;
  bidAmount: number;
  children: ReactNode;
}

export function AuctionBottomSheetFooter(props: AuctionBottomSheetFooterProps) {
  const {
    isInstantPay,
    scheduledShiftDurationInHours,
    breakDurationInMinutes,
    requiresBreak,
    remainingWorkDurationInHours,
    minutesElapsed,
    bidAmount,
    children,
  } = props;

  const { formattedPayAmount: formattedTotalPay } = calculateTotalPay({
    hourlyPayRate: bidAmount,
    hoursWorked: remainingWorkDurationInHours,
  });

  return (
    <DialogFooter withShadow orientation="vertical" sx={{ marginBottom: 4 }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{ width: "100%", justifyContent: "flex-end", mb: 2, mr: 4 }}
      >
        <Stack spacing={2} direction="row">
          <Text variant="body1" color={(theme) => theme.palette.text.primary}>
            Est. {formattedTotalPay}
          </Text>
          <DurationWithBreakDisplay
            showBreakInfo={false}
            requiresBreak={requiresBreak}
            totalDurationInHours={scheduledShiftDurationInHours}
            breakDurationInMinutes={breakDurationInMinutes}
            minutesElapsed={minutesElapsed}
          />
        </Stack>
        {isInstantPay && <InstantPayIndicator />}
      </Stack>
      {children}
    </DialogFooter>
  );
}
